export const mutations = {
    setEstoque(state, data){
        state.estoque = data
    },
    setEstoques(state, data){
        state.estoques = data
    },
    addEstoque(state, data){
        state.estoques.push(data)
    },
    removeEstoque(state, data){
        let index = state.estoques.map(x => x.id).indexOf(data.id);
        state.estoques.splice(index, 1)
    },
    setModalCadastroEstoque(state, status){
        state.modalCadastroEstoque = status
    },
    setModalImprimirEstoque(state, status){
        state.modalImprimirEstoque = status
    },
    setModalExcluirEstoque(state, status){
        state.modalExcluirEstoque = status
    },
    setModalMovimentacaoEstoque(state, status){
        state.modalMovimentacaoEstoque = status
    },
    setListarEstoque(state, status){
        state.listarEstoque = status
    }
}

export default {}